import { useMemo } from "react";
import clsx from "clsx";
import useTranslation from "next-translate/useTranslation";
import SearchBarConsultantCard from "@/components/common/SearchBar/SearchBarConsultantCard";
import SearchBarBlogCard from "@/components/common/SearchBar/SearchBarBlogCard";
import IconSearch from "@/common/icons/search.svg";

const SearchBarLiveContainer = ({ loading, data, isOpen, closeRoutingOnBlur, search, cursor, responsive = true }) => {
  const { t } = useTranslation("common");
  const isEmpty = useMemo(
    () => (data ? Object.values(data).every((item) => item === null || item.length === 0) : true),
    [data]
  );

  // HACK : BORDER (DONT DELETE BORDER LEFT)
  return (
    <div
      className={clsx(
        "absolute top-full -left-4 z-10 mt-3 max-h-[32rem] w-screen space-y-12 overflow-y-auto border-l-[1.5rem] border-transparent bg-white pr-6 shadow-lg lg:left-0 lg:mx-0 lg:w-full lg:border-l-0",
        (!isOpen || (isEmpty && !loading)) && "hidden",
        responsive ? "lg:py-6 lg:px-12" : "lg:p-4"
      )}
    >
      {data ? (
        <>
          {data.suggest.length > 0 && (
            <ul>
              {data.suggest.map((s, index) => (
                <li
                  role="presentation"
                  onClick={() => search(s)}
                  className={clsx(
                    "flex cursor-pointer items-center p-2 text-grey-800 hover:bg-grey-100 focus:bg-grey-100",
                    cursor === index && "bg-grey-100"
                  )}
                  key={s}
                >
                  <IconSearch className={clsx("h-3 w-3 shrink-0", responsive && "lg:h-4 lg:w-4")} />
                  <span className={clsx("ml-4 text-sm", responsive && "lg:text-base")}>{s}</span>
                </li>
              ))}
            </ul>
          )}
          {data.consultants && (
            <section>
              <h4
                className={clsx("mb-4 font-semibold text-orange", responsive && "lg:mb-6")}
              >{t`content-types.consultant`}</h4>
              {data.consultants.map((consultant) => (
                <SearchBarConsultantCard
                  key={consultant.id}
                  consultant={consultant}
                  closeRoutingOnBlur={closeRoutingOnBlur}
                  responsive={responsive}
                />
              ))}
            </section>
          )}
          {data.blogs && (
            <section>
              <h4
                className={clsx("mb-4 font-semibold text-orange", responsive && "lg:mb-6")}
              >{t`content-types.blog`}</h4>
              {data.blogs.map((blog) => (
                <SearchBarBlogCard
                  key={blog.id}
                  blog={blog}
                  closeRoutingOnBlur={closeRoutingOnBlur}
                  responsive={responsive}
                />
              ))}
            </section>
          )}
        </>
      ) : (
        loading && <div className="spinner" />
      )}
    </div>
  );
};

export default SearchBarLiveContainer;
